import script from "./ModalHandlerMostrarClasificacion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalHandlerMostrarClasificacion.vue?vue&type=script&setup=true&lang=ts"

import "./ModalHandlerMostrarClasificacion.vue?vue&type=style&index=0&id=59e0fe6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e0fe6a"]])

export default __exports__